import {
    CHANGE_COLOR,
    CHANGE_TOOL,
    CHANGE_TOOL_WEIGHT,
    CHANGE_ERASER_WEIGHT,
    CHANGE_TEXT_WEIGHT,
    CHANGE_TEXT_FONT_SIZE,
    CHANGE_TEXT_FONT_FAMILY,
    CHANGE_TEXT_FONT_STYLE,
    CHANGE_TEXT_FONT_WEIGHT,
    CHANGE_TEXT_DECORATION,
} from '../actionTypes';
import { TOOL_PEN } from '../../constants';

const initialState = {
    color: '#000000',
    tool: TOOL_PEN,
    toolWeight: 1,
    textWeight: 1,
    textFontSize: 3.5,
    textFontFamily: 'Arial, Helvetica, sans-serif',
    textFontStyle: 'normal',
    textFontWeight: 'normal',
    textDecoration: 'none',
    eraserWeight: 5,
};

const drawing = function (state = initialState, action) {
    if (!action.payload) return state;
    switch (action.type) {
        case CHANGE_COLOR: {
            return {
                ...state,
                color: action.payload,
            };
        }
        case CHANGE_TOOL: {
            return {
                ...state,
                tool: action.payload,
            };
        }
        case CHANGE_TOOL_WEIGHT: {
            return {
                ...state,
                toolWeight: action.payload,
            };
        }
        case CHANGE_TEXT_WEIGHT: {
            return {
                ...state,
                textWeight: action.payload,
            };
        }
        case CHANGE_ERASER_WEIGHT: {
            return {
                ...state,
                eraserWeight: action.payload,
            };
        }
        case CHANGE_TEXT_FONT_SIZE: {
            return {
                ...state,
                textFontSize: action.payload,
            };
        }
        case CHANGE_TEXT_FONT_FAMILY: {
            return {
                ...state,
                textFontFamily: action.payload,
            };
        }
        case CHANGE_TEXT_FONT_STYLE: {
            return {
                ...state,
                textFontStyle: action.payload,
            };
        }
        case CHANGE_TEXT_FONT_WEIGHT: {
            return {
                ...state,
                textFontWeight: action.payload,
            };
        }
        case CHANGE_TEXT_DECORATION: {
            return {
                ...state,
                textDecoration: action.payload,
            };
        }
        default:
            return state;
    }
};

export default drawing;
